// paquetes
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useDropzone } from 'react-dropzone';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import CardAyudarACrear from '../../../componentesEspeciales/cardAyudarAcrear';
import BotonesaPasos from '../../../componentesEspeciales/crearEditar/botonesPasos';
import Paso1 from './pasosCrearEditar/paso1';
import Paso2 from './pasosCrearEditar/paso2';
import Paso3 from './pasosCrearEditar/paso3';
import Paso4 from './pasosCrearEditar/paso4';
import Paso5 from './pasosCrearEditar/paso5';
import ModalPublicar from '../../../componentesEspeciales/crearEditar/modalPublicar';
// funciones
import { validarNoContacto, precioValido, limpiarLineasDetalles } from '../../../funcionesDatos/validacionesCrearEditar';
import { pixelPonerEnRevision, pixelIniciarCreacionServicio, pixelPasoCreacionServicio } from '../../../funcionesDatos/pixelFacebook';
import { gtagPonerEnRevision, gtagIniciarCreacionServicio, gtagPasoCreacionServicio } from '../../../funcionesDatos/pixelGoogle';
import { ttqPonerEnRevision } from '../../../funcionesDatos/pixelTiktok';
import { eventoPonerEnRevision, eventoIniciarCreacionServicio, eventoPasoCreacionServicio } from '../../../funcionesDatos/eventoPropio';
// estilos
import '../../../estilos/servicios.css';
import '../../../estilos/crearEditar.css';

// Capítulos del tutorial completo (video NVGsw2uBKmo), en segundos
const CAPITULOS_VIDEO_COMPLETO = [
  { label: '0:00 Inicio', seconds: 0 },
  { label: '0:24 Paso 1: tipo de servicio', seconds: 24 },
  { label: '1:30 Paso 2: descripción', seconds: 90 },
  { label: '2:59 Paso 3: imágenes del servicio', seconds: 179 },
  { label: '3:25 Paso 4: paquetes', seconds: 205 },
  { label: '6:39 Paso 5: preguntas', seconds: 399 },
];
// Mismo tiempo de inicio, pero indexado por número de paso del wizard (1 a 5)
const INICIO_VIDEO_COMPLETO_POR_PASO = { 1: 24, 2: 90, 3: 179, 4: 205, 5: 399 };

// Capítulos del video guiado por paso (video nDnfyARN4Xw), en segundos
const CAPITULOS_VIDEO_GUIADO = [
  { label: '0:00 Inicio', seconds: 0 },
  { label: '0:13 Paso 1: tipo de servicio', seconds: 13 },
  { label: '0:52 Paso 2: descripción', seconds: 52 },
  { label: '1:26 Paso 3: imágenes del servicio', seconds: 86 },
  { label: '1:51 Paso 4: paquetes', seconds: 111 },
  { label: '3:43 Paso 5: preguntas', seconds: 223 },
];

// (refresh) edición mínima para forzar re-parse del archivo
function CrearEditarServicio() {
  const navigate                    = useNavigate();
  const location                    = useLocation();
  const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; 
  // Variables
  const [cargando, setCargando]     = useState(false);
  const cargandoFinal               = Boolean(cargandoUsuario) || Boolean(cargando);
  const [servicio, setServicio]     = useState(false);
  const idServicioStorageKey = "hpm_idServicio_borrador";
  const [idServicio, setIdServicio] = useState(() => {
    try { return sessionStorage.getItem(idServicioStorageKey) || null; }
    catch (e) { return null; }
  });
  const [cateConfig, setCateConfig] = useState([]); // [{categoria, subcategorias, imagen, icono}]
  const [categoriaSeleccionada, setCategoriaSeleccionada]       = useState("");
  const [subCategoriaSeleccionada, setSubCategoriaSeleccionada] = useState("");

  // Objeto de categoría seleccionada (derivado de cateConfig)
  const categoriaObj             = Array.isArray(cateConfig) ? cateConfig.find((c) => c?.categoria === categoriaSeleccionada) : null;
  const subcategoriasDisponibles = Array.isArray(categoriaObj?.subcategorias) ? categoriaObj.subcategorias : [];
  const [cantidadFaq, setCantidadFaq] = useState(0); // 0 a 5
  const [faq, setFaq]                 = useState([]); // [{ pregunta: "", respuesta: "" }]
  const [cantidadPaquetes, setCantidadPaquetes] = useState(1); // 1, 2 o 3
  const [paqueteActivo, setPaqueteActivo]       = useState('Basico');
  const [paquetes, setPaquetes]                 = useState({
    Basico:   { titulo: 'Básico',   precio: '', unidadEntrega: 'Horas', diasEntrega: '', diasSemana: [], modoAgenda: 'exacta', franjasDia: [], citasDia: '', duracionCitaMin: '', horariosDia: [], descripcion: '', detalles: '' },
    Premium:  { titulo: 'Premium',  precio: '', unidadEntrega: 'Horas', diasEntrega: '', diasSemana: [], modoAgenda: 'exacta', franjasDia: [], citasDia: '', duracionCitaMin: '', horariosDia: [], descripcion: '', detalles: '' },
    Avanzado: { titulo: 'Avanzado', precio: '', unidadEntrega: 'Horas', diasEntrega: '', diasSemana: [], modoAgenda: 'exacta', franjasDia: [], citasDia: '', duracionCitaMin: '', horariosDia: [], descripcion: '', detalles: '' },
  });
  // const ultimoGuardadoRef = useRef({
  //   titulo: "",
  //   descripcion: ""
  // });
  const saltarResetSubcategoriaRef = useRef(false); // evita reset al hidratar desde backend
  const [imagenesUI, setImagenesUI] = useState({
    0: { preview: null, analizando: false },
    1: { preview: null, analizando: false },
    2: { preview: null, analizando: false },
    3: { preview: null, analizando: false },
    4: { preview: null, analizando: false },
    5: { preview: null, analizando: false },
    6: { preview: null, analizando: false },
    7: { preview: null, analizando: false }
  });
  const [formServicio, setFormServicio] = useState({
    titulo: "",
    descripcion: ""
  }); 
  const [paisSeleccionado, setPaisSeleccionado]     = useState("Colombia");
  const [zonaSeleccionada, setZonaSeleccionada]     = useState("");
  const [zonas, setZonas]                           = useState([]);

  const [ciudadSeleccionada, setCiudadSeleccionada] = useState("");
  const [ciudades, setCiudades]                     = useState([]);
  const [subZonaTipo, setSubZonaTipo]               = useState("");
  const [subZonasPorCiudad, setSubZonasPorCiudad]   = useState({});
  const [direccionTexto, setDireccionTexto]         = useState("");
  const [referencia, setReferencia]                 = useState("");
  const [latitud, setLatitud]                       = useState(null);
  const [longitud, setLongitud]                     = useState(null);
  const [precisionUbicacion, setPrecisionUbicacion] = useState("NA");
  const [zonaHoraria, setZonaHoraria]               = useState([]);
  const [zonaHorariaSeleccionada, setZonaHorariaSeleccionada] = useState("");
  const [impuestoPais, setImpuestoPais]             = useState(0);
  // Divisa del servicio (por ahora fijo a COP; luego lo leeremos del servicio / paquete)
  const [divisaServicio, setDivisaServicio] = useState('COP');
  // comisiones
  const [comisionHPM, setComisionHPM]               = useState(0);
  const [desgloseCobro, setDesgloseCobro]           = useState(null); // snapshot completo desde backend
  // PASOS
  const [pasoActual, setPasoActual]                 = useState(1);
  const [tipoServicio, setTipoServicio]             = useState("Nodefinido");
  const [tipoDesplazamiento, setTipoDesplazamiento] = useState("Nodefinido");
  const [servicioUrgente, setServicioUrgente]       = useState(false);
  const [tabVideoActivo, setTabVideoActivo]         = useState('guiado'); // 'guiado' | 'completo'
  const [inicioVideoCompleto, setInicioVideoCompleto] = useState(null); // override manual de capítulo; null = sigue el paso actual
  const [inicioManualGuiado, setInicioManualGuiado] = useState(null); // override manual de capítulo; null = sigue el paso actual


  // Si cambia la categoría, reiniciamos subcategoría
  useEffect(() => {
    // Si la categoría cambió porque estamos hidratando el servicio desde backend,
    // NO reseteamos la subcategoría.
    if (saltarResetSubcategoriaRef.current) {
      saltarResetSubcategoriaRef.current = false;
      return;
    }

    setSubCategoriaSeleccionada("");
  }, [categoriaSeleccionada]);

  // Al avanzar de paso en el wizard, ambos videos vuelven a seguir el paso actual
  useEffect(() => {
    setInicioManualGuiado(null);
    setInicioVideoCompleto(null);
  }, [pasoActual]);

  // Trackear pasos COMPLETADOS de verdad (campos llenos y válidos), no solo "avanzados" — el
  // usuario tiene total libertad para moverse entre pasos sin bloqueo; esto solo observa el
  // estado del formulario cada vez que cambia de paso y marca (una sola vez, sin importar la
  // dirección) el que acaba de dejar si ya cumple sus propios requisitos.
  const pasoAnteriorRef       = useRef(1);
  const servicioCompletadoRef = useRef(false);
  const pasoActualRef         = useRef(1);
  const usuarioIdRef          = useRef(null);
  const pasosCompletadosRef   = useRef(new Set());

  useEffect(() => { pasoActualRef.current = pasoActual;               }, [pasoActual]);
  useEffect(() => { usuarioIdRef.current  = usuario?.idUsuario ?? null; }, [usuario?.idUsuario]);

  // La definición de "paso completo" ya existe más abajo (const checklist = {...}), es la misma
  // que se le muestra al vendedor en la UI del checklist ("Listo"/"Pendiente") — se reusa tal
  // cual para no mantener dos definiciones de "completo" que puedan desincronizarse.
  function pasoEstaCompleto(paso) {
    return checklist[`paso${paso}`] === true;
  }

  // Marca (y dispara el evento de) un paso solo la primera vez que se detecta completo —
  // si ya estaba marcado, no vuelve a disparar nada.
  function marcarPasoSiCompleto(paso) {
    if (pasosCompletadosRef.current.has(paso)) return;
    if (!pasoEstaCompleto(paso)) return;
    pasosCompletadosRef.current.add(paso);
    pixelPasoCreacionServicio({ paso, totalPasos: 5 });
    gtagPasoCreacionServicio({ paso, totalPasos: 5 });
    eventoPasoCreacionServicio({ paso, totalPasos: 5, usuarioId: usuarioIdRef.current });
  }

  useEffect(() => {
    if (pasoActual !== pasoAnteriorRef.current) {
      marcarPasoSiCompleto(pasoAnteriorRef.current);
    }
    pasoAnteriorRef.current = pasoActual;
  }, [pasoActual]);

  // Siempre apunta a la versión más reciente de marcarPasoSiCompleto (cierra sobre el estado del
  // formulario del último render) — la usa el efecto de abandono de abajo, que casi no se
  // re-ejecuta (depende solo de idServicio), para no evaluar con datos del formulario ya viejos.
  const marcarPasoSiCompletoRef = useRef(marcarPasoSiCompleto);
  useEffect(() => { marcarPasoSiCompletoRef.current = marcarPasoSiCompleto; });

  // Detectar abandono: cierre de pestaña (beforeunload) + navegación fuera del flujo (desmonte)
  useEffect(() => {
    if (!idServicio) return;

    const enviarAbandono = (usarBeacon) => {
      if (servicioCompletadoRef.current) return;
      // Última oportunidad de marcar el paso en el que se quedó, por si lo completó pero nunca
      // volvió a cambiar de paso antes de cerrar/salir.
      marcarPasoSiCompletoRef.current(pasoActualRef.current);
      const body = JSON.stringify({
        tipo:      "abandonar_creacion_servicio",
        usuarioId: usuarioIdRef.current,
        payload:   { paso: pasoActualRef.current },
      });
      if (usarBeacon && navigator.sendBeacon) {
        navigator.sendBeacon("/eventos", new Blob([body], { type: "application/json" }));
      } else {
        fetch("/eventos", { method: "POST", headers: { "Content-Type": "application/json" }, body }).catch(() => {});
      }
    };

    const handleBeforeUnload = () => enviarAbandono(true);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      enviarAbandono(false); // cubre "Volver a borrador" y cualquier navegación React Router
    };
  }, [idServicio]);




  // USEEFFECT PRINCIPAL
  useEffect(() => {
    (async () => {
      setCargando(true);
      try {
        // 0) Espera a que Direccionamiento termine de verificar sesión
        if (cargandoUsuario) return;

        // Esta página requiere login
        if (!usuario) { return navigate("/iniciar-sesion"); }

        // 1) Categorías (no dependen del token)
        try {
          const resCategorias = await axios.post("/obtener-categorias");
          setCateConfig(resCategorias.data?.categoriasConfig || []); // contiene arreglo de objetos con toda la info
        } 
        catch (err) {
          console.error("Error al obtener categorías:", err);
          setCateConfig([]);
        }

        // 2) Si es la primera vez, se crea el servicio
        if (!idServicio) {
          const responseServicio = await axios.post("/crear-servicio-borrador", { params: { usuario } });
          const nuevoId = responseServicio?.data?.idServicio;

          if (nuevoId) {
            setIdServicio(nuevoId);
            try { sessionStorage.setItem(idServicioStorageKey, String(nuevoId)); } catch (e) {}
            pixelIniciarCreacionServicio();
            gtagIniciarCreacionServicio();
            eventoIniciarCreacionServicio({ usuarioId: usuario?.idUsuario });
          }
        }

        // 3) Si el servicio ya existe, lo buscamos
        else {
          const resBuscarServicio = await axios.post("/buscar-servicio", { params: { usuario, idServicio } });
          const servicioEncontrado = resBuscarServicio.data.servicio;

          setServicio(servicioEncontrado);
          //console.log("servicio: ", servicioEncontrado);
          // Hidratar tipo de servicio (Paso 1)
          try {
            // TIPO DE SERVICIO 
            const tipoSer = String(servicioEncontrado.tipoServicio);
            setTipoServicio(tipoSer);
            // TIPO DESPLAZAMIENTO — si es Presencial sin desplazamiento válido, fuerza Domicilio
            const td = String(servicioEncontrado?.tipoDesplazamiento || '').trim();
            const tdValido = (td === "Domicilio" || td === "EnLocal") ? td : (tipoSer === "Presencial" ? "Domicilio" : "Nodefinido");
            setTipoDesplazamiento(tdValido);
            setServicioUrgente(!!servicioEncontrado?.urgente);
          } 
          catch (e) {
            setTipoServicio('Nodefinido');
            setTipoDesplazamiento('Nodefinido');
            setServicioUrgente(false);
          }
          // Divisa (si en el futuro el servicio/paquete define moneda)
          // Por ahora mantenemos COP como default.
          try {
            const divisaUI = (servicioEncontrado?.divisa.trim())
            setDivisaServicio(divisaUI);
            //console.log("divisaui: ", divisaUI);
          } 
          catch (e) { console.log("error al obtener divisa") }
          
          const nombreUI = (servicioEncontrado.nombre && servicioEncontrado.nombre !== "NA") ? servicioEncontrado.nombre : "";
          const descUI   = (servicioEncontrado.descripcion && servicioEncontrado.descripcion !== "NA") ? servicioEncontrado.descripcion : "";
          setFormServicio({ titulo: nombreUI, descripcion: descUI, usoIA: servicioEncontrado.usoIA || 0 });

          const catUI = (servicioEncontrado.categoria && servicioEncontrado.categoria !== "NA") ? servicioEncontrado.categoria : "";
          const subUI = (servicioEncontrado.subcategoria && servicioEncontrado.subcategoria !== "NA") ? servicioEncontrado.subcategoria : "";

          // Evita que el useEffect de categoria borre la subcategoría al hidratar
          saltarResetSubcategoriaRef.current = true;
          setCategoriaSeleccionada(catUI);
          setSubCategoriaSeleccionada(subUI);

          // Cargar imágenes existentes
          
          const imagenesGuardadas = Array.isArray(servicioEncontrado.imagenes) ? servicioEncontrado.imagenes : [];
          setImagenesUI(prev => {
            const nuevoEstado = { ...prev };
            for (let i = 0; i < 8; i++) {
              const url = imagenesGuardadas[i];
              if (typeof url === "string" && url.trim() !== "") {
                nuevoEstado[i] = { preview: url, analizando: false };
              }
            }
            return nuevoEstado;
          });

          // Cargar paquetes existentes
          const paquetesDB = Array.isArray(servicioEncontrado.paquetes) ? servicioEncontrado.paquetes : [];
          // si ya tiene paquetes guardados
          if (paquetesDB.length > 0) {
            const tipos = paquetesDB.map(p => p.tipo); // guardamos los tipos de paquetes, básico, premium, avanzado
            const n     = tipos.includes("Avanzado") ? 3 : (tipos.includes("Premium") ? 2 : 1); // guardamos la cantidad de paquetes que tiene guardado.

            setCantidadPaquetes(n);
            setPaqueteActivo("Basico"); // iniciamizamos paquetes en básico
            // reformateamos los datos para mostrarlos en front.
            setPaquetes(prev => {
              const nuevo = { ...prev };
              // recorremos los paquetes
              for (const p of paquetesDB) {
                const key = (p.tipo === "Básico") ? "Basico" : (p.tipo === "Premium" ? "Premium" : "Avanzado");
                const unidadEntregaDB = (p.unidadEntrega === "Horas" || p.unidadEntrega === "Dias") ? p.unidadEntrega : "Horas";

                nuevo[key] = {
                  titulo: p.tipo || nuevo[key].titulo,
                  precio: (p.precio !== undefined && p.precio !== null) ? String(p.precio) : "",
                  unidadEntrega: unidadEntregaDB,
                  diasEntrega: (p.diasEntrega !== undefined && p.diasEntrega !== null) ? String(p.diasEntrega) : "",
                  descripcion: (p.descripcion && p.descripcion !== "NA") ? p.descripcion : "",
                  diasSemana: Array.isArray(p.diasSemana) ? p.diasSemana.map(Number) : [],
                  modoAgenda: (p.modoAgenda === 'flexible' || p.modoAgenda === 'exacta') ? p.modoAgenda : 'exacta',
                  franjasDia: Array.isArray(p.franjasDia) ? p.franjasDia : [],
                  citasDia: (p.citasDia !== undefined && p.citasDia !== null) ? String(p.citasDia) : "",
                  duracionCitaMin: (p.duracionCitaMin !== undefined && p.duracionCitaMin !== null) ? String(p.duracionCitaMin) : "",
                  horariosDia: Array.isArray(p.horariosDia) ? p.horariosDia : [],
                  detalles: Array.isArray(p.detalles) ? p.detalles.join("\n") : ""
                };
              }
              return nuevo;
            });
          }

          // Cargar FAQ
          const faqDB = Array.isArray(servicioEncontrado.faq) ? servicioEncontrado.faq : [];
          if (faqDB.length > 0) {
            const listaFaq = faqDB.slice(0, 5).map(it => ({
              pregunta:  (it?.pregunta && it.pregunta !== "NA") ? String(it.pregunta) : "",
              respuesta: (it?.respuesta && it.respuesta !== "NA") ? String(it.respuesta) : ""
            }));
            setFaq(listaFaq);
            setCantidadFaq(listaFaq.length);
          } else {
            setFaq([]);
            setCantidadFaq(0);
          }

          // GUARDAR DATOS DE UBICACION DESDE DB
          setFormServicio(prev => ({
            ...prev,
            coberturaCompletaCiudad: Boolean(servicioEncontrado?.coberturaCompletaCiudad),
            subzonas: Array.isArray(servicioEncontrado?.subzonas) ? servicioEncontrado.subzonas : []
          }));
          setCiudadSeleccionada(servicioEncontrado.ciudad || "");
          setZonaSeleccionada(servicioEncontrado.zona || ""); // departamento
          setPaisSeleccionado(servicioEncontrado.pais || "Colombia");

          setDireccionTexto(servicioEncontrado?.ubicacion?.direccionTexto || "");
          setReferencia(servicioEncontrado?.ubicacion?.referencia || "");
          setZonaHorariaSeleccionada(servicioEncontrado.zonaHoraria || "");
          setLatitud(servicioEncontrado?.ubicacion?.latitud ?? null);
          setLongitud(servicioEncontrado?.ubicacion?.longitud ?? null);
          setPrecisionUbicacion(servicioEncontrado?.ubicacion?.precision || "NA");

          // Obtener ciudades y subzonas con respecto al pais
          try {
            const resPais = await axios.post("/obtener-info-pais-total", { params: { pais: "Colombia" } });
            const infoPais = resPais.data.contenidoPais;
            const zonasPais = Array.isArray(infoPais.departamentos) ? infoPais.departamentos : [];
            setZonas(zonasPais);
            //console.log("zona pais: ", zonasPais);

            const zonaEncontrada = zonasPais.find( (z) => z?.departamento === (servicioEncontrado?.zona || "") );
            // GUARDAMOS DATOS PARA DROPWODNS INPUTS
            setCiudades(Array.isArray(zonaEncontrada?.ciudades) ? zonaEncontrada.ciudades : []);
            setSubZonaTipo(zonaEncontrada?.subzonasTipo || "");
            setSubZonasPorCiudad(zonaEncontrada?.subzonasPorCiudad || {});
            setZonaHoraria(infoPais.zonas || []);

            if ((!servicioEncontrado?.zonaHoraria || servicioEncontrado.zonaHoraria === "NA") && Array.isArray(infoPais.zonas) && infoPais.zonas.length > 0) {
              setZonaHorariaSeleccionada(infoPais.zonas[0]?.valor || "America/Bogota");
            }
            setImpuestoPais(infoPais.impuesto || 0);
            
          } 
          catch (err) {
            console.error("Error al obtener ciudades:", err);
            setCiudades([]);
          }
        }
      } 
      catch (err) { console.error("Error en CrearEditarServicio (init):", err); } 
      finally { setCargando(false); }
    })();
  }, [usuario, cargandoUsuario, idServicio]);
  


  // useEffect obtener comisiones (depende de país + precio del paquete activo)
  useEffect(() => {
    let cancelado = false;
    let t;

    const precioStr = paquetes?.[paqueteActivo]?.precio;
    const precioNum = Number(String(precioStr || "").replace(/[^0-9]/g, "")); // "50.000" => 50000

    // Solo ejecutamos cuando hay país y precio válido
    if (!paisSeleccionado) return;
    if (!Number.isFinite(precioNum) || precioNum <= 0) return;
    setDesgloseCobro(null);

    t = setTimeout(() => {
      (async () => {
        try {
          // Back retorna: comisionHPM (decimal) y comisionPlataforma (obj)
          const resComisiones = await axios.post("/obtener-comisiones", {
            params: { pais: paisSeleccionado, precio: precioNum, urgente: servicioUrgente }
          });
          //console.log("obtener comisiones: ", resComisiones);
          if (cancelado) return;

          const pctHpm = Number(resComisiones?.data?.comisionHPM || 0);
          setComisionHPM(Number.isFinite(pctHpm) ? pctHpm : 0);

          const dBack = resComisiones?.data?.desglose || null;
          setDesgloseCobro(dBack);
        }
        catch (err) { console.error("Error al obtener comisiones:", err); }
      })();
    }, 450);

    return () => {
      cancelado = true;
      if (t) clearTimeout(t);
    };
  }, [paisSeleccionado, paqueteActivo, paquetes, servicioUrgente]);



  

  




  // F A Q  funciones -------------------------------------------------------------------------
  // garantiza que el dropdown tenga exatamente la cantidad entre 0 y 5
  function asegurarFaqLongitud(n) {
    const num = Math.max(0, Math.min(5, Number(n || 0))); // convierte n a número, si viene vacío usa 0, lo limita entre 0 y 5.

    setFaq(prev => {
      const copia = Array.isArray(prev) ? [...prev] : []; // toma el estado anterior y lo copia.
      while (copia.length < num) copia.push({ pregunta: "", respuesta: "" }); // si faltan elementos, agrega objetos vacíos hsta llegar a num.
      return copia.slice(0, num);  // Si sobran elementos, recorta el array a num.
    });
    setCantidadFaq(num);
  }

  // actualizar un campo específico (pregunta o respuesta) de una pregunta específica del FAQ.
  function actualizarFaq(index, campo, valor) {
    setFaq(prev => {
      const copia = Array.isArray(prev) ? [...prev] : []; // copia el array anterior.
      if (!copia[index]) copia[index] = { pregunta: "", respuesta: "" }; // Por seguridad, si esa posición no existe (por algún bug o cambio de cantidad), la crea.
      copia[index] = { ...copia[index], [campo]: valor }; // actualzia solo un campo. si campo es "pregunta", cambia pregunta, sio campo es "respuesta", cambia respuesta
      return copia;
    });
  }
  
  // toma lo que el usuario escribió en el FAQ (estado faq) y lo convierte en un arreglo “limpio” listo para enviarlo al backend en params.faq.
  function construirFaqParaBackend() {
    const lista = Array.isArray(faq) ? faq.slice(0, cantidadFaq) : []; // Asegura que faq sea un arreglo Y toma solo los primeros cantidadFaq elementos.
    const salida = [];

    for (const item of lista) {
      // convierte y elimina el espacio final
      const pregunta  = String(item?.pregunta || "").trim();
      const respuesta = String(item?.respuesta || "").trim();

      // si está vacío, no lo guardamos
      if (!pregunta && !respuesta) continue;

      salida.push({
        pregunta: pregunta ? pregunta : "NA",
        respuesta: respuesta ? respuesta : "NA"
      });
    }

    return salida;
  }





  // IMAGENES funciones -------------------------------------------------------------------------
  // Limites de imagen
  const MAX_MB   = 6; // limite duro (bloquea)
  const RECOM_MB = 2; // recomendado (solo aviso)
  const MAX_SIZE = MAX_MB * 1024 * 1024;
  const dropOpts = (index) => ({
    accept: { 'image/*': ['.jpg', '.jpeg', '.png', '.webp'] },
    maxSize: MAX_SIZE,
    multiple: false,
    onDrop: (files) => subirImagenes(files, index),
    onDropRejected: (rejections) => {
      const r    = rejections?.[0];
      const code = r?.errors?.[0]?.code;

      let msg = "Archivo no permitido.";
      if (code === "file-too-large")    msg = "La imagen pesa demasiado. Máximo " + MAX_MB + " MB. Recomendado: " + RECOM_MB + " MB y formato cuadrado (1:1).";
      if (code === "file-invalid-type") msg = "Formato no permitido. Usa JPG, PNG o WebP.";

      Swal.fire({ icon: "error", title: "Imagen inválida", text: msg, customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
    }
  });

  const { getRootProps: root0, getInputProps: input0 } = useDropzone(dropOpts(0));
  const { getRootProps: root1, getInputProps: input1 } = useDropzone(dropOpts(1));
  const { getRootProps: root2, getInputProps: input2 } = useDropzone(dropOpts(2));
  const { getRootProps: root3, getInputProps: input3 } = useDropzone(dropOpts(3));
  const { getRootProps: root4, getInputProps: input4 } = useDropzone(dropOpts(4));
  const { getRootProps: root5, getInputProps: input5 } = useDropzone(dropOpts(5));
  const { getRootProps: root6, getInputProps: input6 } = useDropzone(dropOpts(6));
  const { getRootProps: root7, getInputProps: input7 } = useDropzone(dropOpts(7));

  const dropzonesImagenes = [
    { index: 0, getRootProps: root0, getInputProps: input0 },
    { index: 1, getRootProps: root1, getInputProps: input1 },
    { index: 2, getRootProps: root2, getInputProps: input2 },
    { index: 3, getRootProps: root3, getInputProps: input3 },
    { index: 4, getRootProps: root4, getInputProps: input4 },
    { index: 5, getRootProps: root5, getInputProps: input5 },
    { index: 6, getRootProps: root6, getInputProps: input6 },
    { index: 7, getRootProps: root7, getInputProps: input7 },
  ];

  async function subirImagenes(files, index){
    if (!Array.isArray(files) || files.length === 0) {
      return Swal.fire({ icon: 'error', title: "Error", text: "No agregaste ninguna imagen", customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' }, }); 
    }

    if (categoriaSeleccionada === "" || subCategoriaSeleccionada === "") {
      return Swal.fire({ icon: 'error', title: "Error", text: "Debes seleccionar una categoría y subcategoría para subir una imagen.", customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' }, });
    }

    // Usamos solo la primera imagen para este slot
    const file = files[0];
    // Aviso (no bloquea): recomendado <= 2MB
    const sizeMb = (file && file.size) ? (file.size / (1024 * 1024)) : 0;
    if (sizeMb > RECOM_MB && sizeMb <= MAX_MB) {
      Swal.fire({
        icon: 'info',
        title: 'Recomendación',
        text: 'Para que cargue más rápido, intenta que la foto pese menos de ' + RECOM_MB + ' MB y sea cuadrada (1:1). Igual la subiremos.',
        timer: 2200,
        showConfirmButton: false,
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' },
      });
    }

    // Si la imagen fue rechazada o hubo error, limpiamos por completo ese slot
    setImagenesUI(prev => ({
      ...prev,
      [index]: {
        preview: null,
        analizando: false
      }
    }));

    setCargando(true);

    try {
      const formData = new FormData();
      formData.append("imagen", file);

      const response = await axios.post('/subida-imagenes-servicios', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: {
          usuario: usuario.username,
          categoria: categoriaSeleccionada,
          subcategoria: subCategoriaSeleccionada,
          idServicio: idServicio,
          numeroContenido: index
        }
      });

      //console.log("respuesta: ", response);

      const urlServidor = response?.data?.url;

      // Si el backend devuelve la URL, usamos esa como preview definitiva
      if (urlServidor) {
        setImagenesUI(prev => ({
          ...prev,
          [index]: {
            // usamos ya la URL real de S3
            preview: urlServidor,
            analizando: false
          }
        }));
      } 
      else {
        // Si por alguna razón no llegó la URL, solo quitamos el "analizando"
        setImagenesUI(prev => ({
          ...prev,
          [index]: {
            ...prev[index],
            analizando: false
          }
        }));
      }
    } 
    catch (err) {
      console.error("Error:", err);

      // Quitamos el estado "analizando" pero dejamos la preview local
      setImagenesUI(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          analizando: false
        }
      }));

      const mensajeServidor = err?.response?.data?.mensaje;

      Swal.fire({ icon: 'error', title: "Error", text: mensajeServidor || "Ocurrió un problema al subir o analizar la imagen.", customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' }, });
    } 
    finally { setCargando(false);  }
  }





  // PAQUETES funciones  -------------------------------------------------------------------------
  function construirPaquetesParaBackend(soloGuardar = false) {
    const orden = ["Basico", "Premium", "Avanzado"].slice(0, cantidadPaquetes);
    const salida = [];

    for (const key of orden) {
      const p = paquetes[key];
      const tipo = key === "Basico" ? "Básico" : (key === "Premium" ? "Premium" : "Avanzado");

      const precio = Number(String(p?.precio || "").replace(/[^0-9]/g, "")); // Precio: en CO el punto es separador de miles ("50.000" => 50000)
      const unidadEntrega = (p?.unidadEntrega === "Horas") ? "Horas" : "Dias";
      // Cantidades
      const diasEntrega  = Number(String(p?.diasEntrega  || "").replace(/[^0-9]/g, ""));
      // horasEntrega eliminado

      // Al guardar progreso no exigimos precio para no perder datos como diasSemana; al publicar sí.
      if (!soloGuardar && (!p || !p.precio || Number.isNaN(precio) || precio <= 0)) continue;

      salida.push({
        tipo,
        descripcion: (p.descripcion && p.descripcion.trim()) ? p.descripcion.trim() : "NA",
        detalles: limpiarLineasDetalles(p.detalles),
        unidadEntrega,
        diasSemana: Array.isArray(p?.diasSemana) ? p.diasSemana : [],
        modoAgenda: (unidadEntrega === "Horas") ? ((p?.modoAgenda === 'flexible') ? 'flexible' : 'exacta') : 'NA',
        franjasDia: (unidadEntrega === "Horas" && p?.modoAgenda === 'flexible' && Array.isArray(p?.franjasDia)) ? p.franjasDia : [],
        citasDia: (unidadEntrega === "Horas") ? (Number(String(p?.citasDia || "").replace(/[^0-9]/g, "")) || 0) : 0,
        duracionCitaMin: (unidadEntrega === "Horas") ? (Number(String(p?.duracionCitaMin || "").replace(/[^0-9]/g, "")) || 0) : 0,
        horariosDia: (unidadEntrega === "Horas" && Array.isArray(p?.horariosDia)) ? p.horariosDia : [],
        diasEntrega: (unidadEntrega === "Dias") ? ((!Number.isNaN(diasEntrega) && diasEntrega > 0) ? diasEntrega : 1) : 1,
        // horasEntrega eliminado
        precio,
        divisa: "COP"
      });
    }

    return salida;
  }

  function actualizarPaquete(cual, campo, valor) {
    setPaquetes(prev => ({
      ...prev,
      [cual]: { ...prev[cual], [campo]: valor }
    }));
  }

  function actualizarTodosPaquetes(campo, valor) {
    setPaquetes(prev => ({
      Basico:   { ...prev.Basico,   [campo]: valor },
      Premium:  { ...prev.Premium,  [campo]: valor },
      Avanzado: { ...prev.Avanzado, [campo]: valor },
    }));
  }

  // Estado para controlar la flecha (acordeón agenda por horas)
  const [agendaAbierta, setAgendaAbierta] = useState({ Basico: false, Premium: false, Avanzado: false });
  

  

  

  function checklistPaso4Completo() {
    const orden = ["Basico", "Premium", "Avanzado"].slice(0, Number(cantidadPaquetes || 1));

    return orden.some((key) => {
      const p = paquetes?.[key] || {};

      const diasSemana = Array.isArray(p?.diasSemana) ? p.diasSemana : [];
      if (diasSemana.length < 1) return false;

      const precio = Number(String(p?.precio || "").replace(/[^0-9]/g, ""));
      if (!Number.isFinite(precio) || precio <= 0) return false;

      const unidadEntrega = p?.unidadEntrega === "Horas" ? "Horas" : "Dias";

      if (unidadEntrega === "Dias") {
        const diasEntrega = Number(String(p?.diasEntrega || "").replace(/[^0-9]/g, ""));
        if (!Number.isFinite(diasEntrega) || diasEntrega <= 0) return false;
      }

      if (unidadEntrega === "Horas") {
        const citasDia = Number(String(p?.citasDia || "").replace(/[^0-9]/g, ""));
        const duracionCitaMin = Number(String(p?.duracionCitaMin || "").replace(/[^0-9]/g, ""));
        if (!Number.isFinite(citasDia) || citasDia <= 0) return false;
        if (!Number.isFinite(duracionCitaMin) || duracionCitaMin <= 0) return false;

        const modoAgenda = p?.modoAgenda === "flexible" ? "flexible" : "exacta";

        if (modoAgenda === "flexible") {
          const franjasDia = Array.isArray(p?.franjasDia) ? p.franjasDia : [];
          if (franjasDia.length < 1) return false;
        }

        if (modoAgenda === "exacta") {
          const horariosDia = Array.isArray(p?.horariosDia)
            ? p.horariosDia.filter((h) => String(h || "").trim() !== "")
            : [];
          if (horariosDia.length < 1) return false;
        }
      }

      const descripcion = String(p?.descripcion || "").trim();
      if (!descripcion) return false;

      const detalles = limpiarLineasDetalles(p?.detalles);
      if (!Array.isArray(detalles) || detalles.length < 1) return false;

      return true;
    });
  }
  // Checklist (MVP) -------------------------------------------------------------------------
  const checklist = {
    paso1:
      tipoServicio === "Digital" ||
      (
        tipoServicio === "Presencial" &&
        (tipoDesplazamiento === "Domicilio" || tipoDesplazamiento === "EnLocal")
      ),
    paso2:
      (formServicio.titulo || '').trim().length >= 5 &&
      (formServicio.descripcion || '').trim().length >= 15 &&
      !!categoriaSeleccionada && categoriaSeleccionada !== "NA" &&
      !!subCategoriaSeleccionada && subCategoriaSeleccionada !== "NA" &&
      (
        tipoServicio === "Digital" ||
        (
          tipoServicio === "Presencial" &&
          tipoDesplazamiento === "Domicilio" &&
          !!zonaSeleccionada && zonaSeleccionada !== "NA" &&
          !!ciudadSeleccionada && ciudadSeleccionada !== "NA"
        ) ||
        (
          tipoServicio === "Presencial" &&
          tipoDesplazamiento === "EnLocal" &&
          !!zonaSeleccionada && zonaSeleccionada !== "NA" &&
          !!ciudadSeleccionada && ciudadSeleccionada !== "NA" &&
          !!String(direccionTexto || '').trim() &&
          latitud !== null &&
          longitud !== null
        )
      ),
    paso3: [0, 1, 2, 3, 4, 5, 6, 7].some((idx) => {
      const url = imagenesUI?.[idx]?.preview;
      return typeof url === "string" && url.trim() !== "";
    }),
    paso4: checklistPaso4Completo(),
    paso5: (construirFaqParaBackend()?.length || 0) >= 1,
  };

  const totalChecks       = Object.keys(checklist).length;
  const checksOk          = Object.values(checklist).filter(Boolean).length;
  const progresoChecklist = Math.round((checksOk / totalChecks) * 100);
  // función para modificar todos los titulos, parrafos con ternary y simplificar el trabajo
  function badgeChecklist(ok) { return ok ? <span className="badge bg-success">Listo</span> : <span className="badge bg-secondary">Pendiente</span>; }






  // VALIDACIONES DE GUARDADO COMPLETO (solo cuando incluirPaquetes=true)
  /**
   * Helper para detectar si un string es una URL.
   * Nota: esta función existe como utilitario para ayudar a otras validaciones (por ejemplo, en ponerEnRevision y otros lugares),
   * pero no se usa directamente en validarAntesDeGuardarCompleto(), ya que la validación de URLs y teléfonos se realiza con los helpers más robustos abajo.
   */
  // === BLOQUEO DE CONTACTO: URLs y teléfonos ===
  function validarPaqueteCompleto(key) {
    const p = paquetes?.[key] || {};
    const errores = [];

    // Días semana
    const dias = Array.isArray(p.diasSemana) ? p.diasSemana : [];
    if (dias.length === 0) errores.push("Selecciona los días de la semana");

    // Título 
    const titulo = String(p.titulo || "").trim();
    if (!titulo) errores.push("Escribe el título del paquete");

    // Precio
    if (!precioValido(p.precio)) errores.push("Ingresa un precio válido");

    // Descripción corta
    const desc = String(p.descripcion || "").trim();
    if (!desc || desc.length < 15) errores.push("La descripción corta debe tener al menos 15 caracteres");

    // Incluye (detalles)
    const det = String(p.detalles || "").trim();
    if (!det || det.length < 10) errores.push("El campo 'Incluye' debe tener al menos 10 caracteres");

    // Bloqueo de contacto (evita costos de moderación y rechazos)
    validarNoContacto({ etiqueta: `Paquete ${key} - Descripción corta`, texto: desc, errores });
    validarNoContacto({ etiqueta: `Paquete ${key} - Incluye`, texto: det, errores });

    // Agenda
    const unidad = (p.unidadEntrega === "Horas") ? "Horas" : "Dias";
    if (unidad === "Dias") {
      const dEnt = Number(String(p.diasEntrega || "").replace(/[^0-9]/g, ""));
      if (!Number.isFinite(dEnt) || dEnt <= 0) errores.push("Ingresa cuántos días de entrega tiene el paquete");
    }
    if (unidad === "Horas") {
      const citas = Number(String(p.citasDia || "").replace(/[^0-9]/g, ""));
      const durMin = Number(String(p.duracionCitaMin || "").replace(/[^0-9]/g, ""));

      if (!Number.isFinite(citas) || citas <= 0) errores.push("Selecciona cuántos servicios haces en un día");
      if (!Number.isFinite(durMin) || durMin <= 0) errores.push("Ingresa cuánto dura cada servicio (min)");

      const modo = (p.modoAgenda === "flexible") ? "flexible" : "exacta";
      if (modo === "exacta") {
        const hor = Array.isArray(p.horariosDia) ? p.horariosDia : [];
        if (hor.length < 1 || hor.length !== citas) errores.push("Debes configurar todos los horarios exactos");
        const faltan = hor.filter((h) => !String(h || "").trim()).length;
        if (faltan > 0) errores.push("Hay horarios exactos vacíos");
      }
      else {
        const franjas = Array.isArray(p.franjasDia) ? p.franjasDia : [];
        if (franjas.length === 0) errores.push("Selecciona al menos una franja (mañana/tarde/noche)");
      }
    }

    return errores;
  }

  function validarFaqCompleto() {
    const errores = [];
    const n = Number(cantidadFaq || 0);
    if (!n) return errores;

    const lista = Array.isArray(faq) ? faq.slice(0, n) : [];
    // Deben venir EXACTAMENTE n items (cuando el dropdown dice n)
    if (lista.length !== n) {
      errores.push("Debes completar todas las preguntas del FAQ");
      return errores;
    }

    lista.forEach((it, idx) => {
      const pregunta  = String(it?.pregunta  || "").trim();
      const respuesta = String(it?.respuesta || "").trim();
      if (pregunta.length < 10)  errores.push(`FAQ ${idx + 1}: la pregunta debe tener al menos 10 caracteres.`);
      if (respuesta.length < 20) errores.push(`FAQ ${idx + 1}: la respuesta debe tener al menos 20 caracteres.`);
      // Bloqueo de contacto en FAQ
      validarNoContacto({ etiqueta: `FAQ ${idx + 1} - Pregunta`,  texto: pregunta,  errores });
      validarNoContacto({ etiqueta: `FAQ ${idx + 1} - Respuesta`, texto: respuesta, errores });
    });

    return errores;
  }

  function validarAntesDeGuardarCompleto() {
    const errores = [];

    // Textos del servicio
    const titulo = String(formServicio?.titulo || "").trim();
    const descripcion = String(formServicio?.descripcion || "").trim();
    if (titulo.length < 5) errores.push("Título del servicio: mínimo 5 caracteres");
    if (descripcion.length < 15) errores.push("Descripción del servicio: mínimo 15 caracteres");

    // Bloqueo de contacto en descripción del servicio
    validarNoContacto({ etiqueta: "Descripción del servicio", texto: descripcion, errores });

    // Paquetes: deben estar completos según cantidadPaquetes
    const orden = ["Basico", "Premium", "Avanzado"].slice(0, Number(cantidadPaquetes || 1));
    for (const key of orden) {
      const errs = validarPaqueteCompleto(key);
      if (errs.length > 0) {
        const nombre = key === "Basico" ? "Básico" : (key === "Premium" ? "Premium" : "Avanzado");
        errores.push(`<b>Paquete ${nombre}:</b> ${errs.join(", ")}`);
      }
    }

    // FAQ completo según cantidadFaq
    const errsFaq = validarFaqCompleto();
    if (errsFaq.length > 0) {
      errores.push(...errsFaq.map((e) => `<b>${e}</b>`));
    }

    return errores;
  }
  
  async function guardarProgreso({ mostrarAlerta, incluirPaquetes } = {}) {
    //console.log("guardar progreso.");
    if (!usuario || !idServicio) return;
    try { sessionStorage.setItem(idServicioStorageKey, String(idServicio)); } catch (e) {}

    try {
      //console.log("antes de enviar: ", tipoServicio, " y ", tipoDesplazamiento);
      //console.log("latitud y longitud: ", latitud, " y ", longitud);
      //console.log("subzonas: ", formServicio);
      const params = {
        usuario,
        idServicio,
        nombre: formServicio.titulo,
        descripcion: formServicio.descripcion,
        categoria: categoriaSeleccionada,
        subcategoria: subCategoriaSeleccionada,
        zona: zonaSeleccionada,
        ciudad: ciudadSeleccionada,
        subZonaTipo,
        subzonas: formServicio.subzonas,
        coberturaCompletaCiudad: Boolean(formServicio?.coberturaCompletaCiudad),
        pais: paisSeleccionado,
        zonaHoraria: zonaHorariaSeleccionada,
        tipoServicio,
        tipoDesplazamiento: tipoServicio === "Presencial" ? tipoDesplazamiento : "NA",
        urgente: tipoServicio === "Presencial" ? servicioUrgente : false,
        ubicacion: {
          direccionTexto,
          referencia,
          latitud,
          longitud,
          precision: precisionUbicacion,
        },
        
      };

      if (incluirPaquetes) {
        const paquetesAenviar = construirPaquetesParaBackend(true);
        params.paquetes = paquetesAenviar;
        // FAQ también se guarda junto con los paquetes
        params.faq = construirFaqParaBackend();
      }

      await axios.post("/guardar-progreso", { params });


      if (mostrarAlerta) {  Swal.fire({ icon: 'success', title: "Progreso guardado", timer: 1200, showConfirmButton: false }); }

      //console.log("Progreso guardado");
    } 
    catch (err) { console.error("Error guardando progreso:", err); }
  }


  // Validación completa del servicio (paso 1 a 5), sin efectos secundarios.
  // La usa ModalPublicar para mostrar los errores ANTES de pedir info personal
  // o verificación de identidad, y también ponerEnRevision como último seguro.
  function construirErroresServicio() {
      const errores = [];

      // Tipo de servicio (paso 1)
      if (tipoServicio !== "Digital" && tipoServicio !== "Presencial") {
        errores.push("Debes seleccionar el tipo de servicio (Presencial o Digital).");
      }
      if (tipoServicio === "Presencial" && tipoDesplazamiento !== "Domicilio" && tipoDesplazamiento !== "EnLocal") {
        errores.push("Debes seleccionar cómo prestarás el servicio (Domicilio o En local).");
      }

      // Fotos
      const fotosSubidas = [0, 1, 2, 3, 4, 5, 6, 7].filter((idx) => {
        const url = imagenesUI?.[idx]?.preview;
        return typeof url === "string" && url.trim() !== "";
      });
      if (fotosSubidas.length < 1) {
        errores.push("Debes subir al menos 1 foto del servicio.");
      }

      // Título y descripción
      const titulo     = String(formServicio?.titulo     || "").trim();
      const descripcion = String(formServicio?.descripcion || "").trim();
      if (titulo.length < 5) {
        errores.push("El título debe tener al menos 5 caracteres.");
      }
      if (descripcion.length < 15) {
        errores.push("La descripción debe tener al menos 15 caracteres.");
      }

      // Bloqueo de contacto en descripción
      const bloqueos = [];
      validarNoContacto({ etiqueta: "Descripción del servicio", texto: descripcion, errores: bloqueos });
      errores.push(...bloqueos);

      // Categoría y subcategoría
      if (!categoriaSeleccionada || categoriaSeleccionada === "NA") {
        errores.push("Debes seleccionar una categoría.");
      }
      if (!subCategoriaSeleccionada || subCategoriaSeleccionada === "NA") {
        errores.push("Debes seleccionar una subcategoría.");
      }

      // Ubicación (solo Presencial)
      if (tipoServicio === "Presencial") {
        const subzonasSeleccionadas     = Array.isArray(formServicio?.subzonas) ? formServicio.subzonas : [];
        const coberturaCompletaCiudad   = Boolean(formServicio?.coberturaCompletaCiudad);
        const subzonasDisponiblesCiudad = Array.isArray(subZonasPorCiudad?.[ciudadSeleccionada]) ? subZonasPorCiudad[ciudadSeleccionada] : [];
        const ciudadTieneSubzonas       = subzonasDisponiblesCiudad.length > 0;

        if (!zonaSeleccionada || zonaSeleccionada === "NA") {
          errores.push("Debes seleccionar una zona (departamento).");
        }
        if (!ciudadSeleccionada || ciudadSeleccionada === "NA") {
          errores.push("Debes seleccionar una ciudad.");
        }
        if (ciudadTieneSubzonas && !coberturaCompletaCiudad && subzonasSeleccionadas.length < 1) {
          errores.push("Debes seleccionar al menos una subzona o indicar cobertura completa de la ciudad.");
        }
        if (tipoDesplazamiento === "EnLocal") {
          if (!String(direccionTexto || "").trim()) {
            errores.push("Debes escribir la dirección exacta de tu local.");
          }
          if (!String(referencia || "").trim()) {
            errores.push("Debes escribir una referencia de tu local.");
          }
          if (latitud === null || longitud === null) {
            errores.push("Debes marcar la ubicación exacta en el mapa.");
          }
        }
      }

      // Paquetes — validar completamente cada paquete activo
      const ordenPaquetes = ["Basico", "Premium", "Avanzado"].slice(0, Number(cantidadPaquetes || 1));
      for (const key of ordenPaquetes) {
        const errsPaquete = validarPaqueteCompleto(key);
        if (errsPaquete.length > 0) {
          const nombre = key === "Basico" ? "Básico" : key === "Premium" ? "Premium" : "Avanzado";
          errores.push(...errsPaquete.map((e) => `Paquete ${nombre}: ${e}.`));
        }
      }

      // Urgente: doble seguro — la UI ya lo previene, pero validamos al publicar
      if (servicioUrgente) {
        const agendaBase = paquetes?.Basico;
        if ((agendaBase?.unidadEntrega || "Horas") === "Dias") {
          errores.push("El modo urgente no es compatible con servicios por días.");
        }
        if ((agendaBase?.modoAgenda || "exacta") === "flexible") {
          errores.push("El modo urgente no es compatible con horarios flexibles.");
        }
      }

      // FAQ
      if (Number(cantidadFaq || 0) < 1) {
        errores.push("Debes agregar al menos 1 pregunta en el FAQ.");
      } else {
        const errsFaq = validarFaqCompleto();
        errores.push(...errsFaq);
      }

      return errores;
  }

  async function ponerEnRevision() {
    setCargando(true);
    try {
      if (!idServicio) {
        return Swal.fire({ icon: "info", title: "Aún no disponible", text: "Espera un momento y vuelve a intentar." });
      }

      // Nota: ModalPublicar ya muestra estos mismos errores antes de llegar aquí;
      // esto queda como último seguro por si se llama a esta función de otro modo.
      const errores = construirErroresServicio();

      if (errores.length > 0) {
        return Swal.fire({
          icon: "error",
          title: "Completa tu servicio antes de publicar",
          html: `<div style="text-align:left;font-size:14px;line-height:1.6"><ul style="padding-left:18px;margin:0">${errores.map((e) => `<li>${e}</li>`).join("")}</ul></div>`,
          confirmButtonText: "Entendido",
          customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
        });
      }

      // Todas las validaciones pasaron. Antes de publicar, forzamos el guardado
      // de lo que hay en pantalla — construirErroresServicio() valida el estado
      // de React, no lo que ya quedó guardado en la base de datos. Sin este
      // guardado, podríamos publicar una versión vieja/incompleta del servicio
      // si el usuario editó algo y nunca se guardó (ni manual ni automático).
      await guardarProgreso({ mostrarAlerta: false, incluirPaquetes: true });

      await axios.post("/servicio-en-revision-aws", {
        params: { idServicio, idUsuario: usuario.idUsuario },
      });

      pixelPonerEnRevision({ idServicio, categoria: categoriaSeleccionada });
      gtagPonerEnRevision({ idServicio, categoria: categoriaSeleccionada });
      ttqPonerEnRevision({ idServicio, categoria: categoriaSeleccionada });
      eventoPonerEnRevision({ idServicio, categoria: categoriaSeleccionada, usuarioId: usuario?.idUsuario });
      // Si publicó, las 5 validaciones ya pasaron (construirErroresServicio no dejó pasar
      // errores) — cubre el caso de terminar el paso 5 sin volver a cambiar de paso antes de publicar.
      [1, 2, 3, 4, 5].forEach(marcarPasoSiCompleto);
      servicioCompletadoRef.current = true; // evita contar esto como abandono
      Swal.fire({ icon: "success", title: "Servicio puesto en revisión correctamente. Vuelve en un momento para revisar su estado.", timer: 1200, showConfirmButton: false });
      return navigate("/vendedor/servicios");
    }
    catch (err) {
      console.log("error al poner el servicio en revisión. ", err);
      Swal.fire({ icon: "error", title: "Error al poner el servicio en revisión", timer: 1200, showConfirmButton: false });
    }
    finally {
      setCargando(false);
    }
  }


  

  async function cambiarTipoYpaso2() {
  try {
    // Guardamos solo datos base (sin paquetes)
    await guardarProgreso({ mostrarAlerta: false, incluirPaquetes: false });
    setPasoActual(2);
  } 
  catch (err) {
    Swal.fire({
      icon: "error",
      title: "No se pudo guardar",
      text: "Intenta de nuevo.",
      customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
    });
  }
  }



  //console.log("SUBZONAS SELECCIONADAS: ", subzonas);



  return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
      {/* body */}
      <div className="flex-grow-1 container-fluid contenedorAdaptador ">
        
        
        {/* Contenedor título  */}
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
          <div className="container">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              {/* título */}
              <h1 className="h2 text-dark mb-0">Crear Servicio</h1>

              {/* Botones */}
              <div className="btn-toolbar mb-2 mb-md-0 ms-auto">
                <div className="btn-group">
                  {/* VOLVER */}
                  <a href='/vendedor/servicios' className="btn btn-primary d-flex justify-content-center align-items-center">
                    <i className="bi bi-arrow-left me-2"></i>
                    Volver a borrador
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        

        {/* Contenedor 1 */}
        <div className="container p-4 p-md-5 mb-4 bg-body-tertiary rounded-3">
          <div className="row justify-content-center">
            {/* Checklist */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                {/* Contenedor título */}
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <div>
                    <h5 className="mb-1">Checklist del servicio</h5>
                    <small className="text-muted">Completa estos pasos para publicar más rápido.</small>
                  </div>
                  <div className="text-end">
                    <div className="fw-semibold">{progresoChecklist}%</div>
                    <small className="text-muted">{checksOk}/{totalChecks}</small>
                  </div>
                </div>
                
                {/* BARRA DE PROGRESO */}
                <div className="progress mt-3" role="progressbar" aria-label="Progreso" aria-valuenow={progresoChecklist} aria-valuemin="0" aria-valuemax="100">
                  <div className="progress-bar" style={{ width: `${progresoChecklist}%` }}></div>
                </div>

                {/* CAMPOS CHECKLIST */}
                <div className="row g-2 mt-3">
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="d-flex align-items-center justify-content-between border rounded p-2 bg-white">
                      <span>✅ Tipo de servicio</span>
                      {badgeChecklist(checklist.paso1)}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="d-flex align-items-center justify-content-between border rounded p-2 bg-white">
                      <span>✅ Descripción</span>
                      {badgeChecklist(checklist.paso2)}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="d-flex align-items-center justify-content-between border rounded p-2 bg-white">
                      <span>✅ Imágenes</span>
                      {badgeChecklist(checklist.paso3)}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="d-flex align-items-center justify-content-between border rounded p-2 bg-white">
                      <span>✅ Paquetes</span>
                      {badgeChecklist(checklist.paso4)}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="d-flex align-items-center justify-content-between border rounded p-2 bg-white">
                      <span>✅ FAQ</span>
                      {badgeChecklist(checklist.paso5)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Aviso importante: no compartir datos de contacto */}
            <div className="alert alert-info border rounded-3 shadow-sm mb-4" role="alert" style={{ padding: '16px' }}>
              <div className="fw-semibold" style={{ fontSize: '18px' }}>🚫 Importante</div>
              <div className="mt-2" style={{ fontSize: '16px' }}>
                En ninguna descripción de servicio, paquete o FAQ, puedes añadir links, teléfonos, correos electrónicos o redes sociales, o el servicio no será aprobado.
              </div>
            </div>


            {/* Video instructivo */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                  <div>
                    <h5 className="mb-1">Video explicativo</h5>
                    <small className="text-muted">Mira este video antes de continuar con la creación de tu servicio.</small>
                  </div>
                </div>

                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link ${tabVideoActivo === 'guiado' ? 'active' : ''}`}
                      onClick={() => setTabVideoActivo('guiado')}
                    >
                      Guía por paso
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      type="button"
                      className={`nav-link fw-semibold d-flex align-items-center gap-2 ${tabVideoActivo === 'completo' ? 'active' : ''}`}
                      onClick={() => setTabVideoActivo('completo')}
                      style={{ color: 'var(--blanco)', backgroundColor: 'var(--naranja-mapa)', borderColor: 'var(--naranja-mapa)' }}
                    >
                      <i className="bi bi-play-circle-fill"></i>
                      Tutorial completo
                    </button>
                  </li>
                </ul>

                {tabVideoActivo === 'guiado' ? (
                  <>
                    <div className="ratio ratio-16x9 rounded overflow-hidden">
                      <iframe
                        key={inicioManualGuiado ?? `paso-${pasoActual}`}
                        src={`https://www.youtube.com/embed/nDnfyARN4Xw?rel=0&start=${inicioManualGuiado ?? ({ 1: 13, 2: 52, 3: 86, 4: 111, 5: 223 }[pasoActual] ?? 0)}`}
                        title="Video explicativo para crear servicio"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      />
                    </div>

                    <div className="d-flex gap-2 mt-2" style={{ overflowX: 'auto', flexWrap: 'nowrap', paddingBottom: '4px' }}>
                      {CAPITULOS_VIDEO_GUIADO.map((cap) => {
                        const activo = (inicioManualGuiado ?? { 1: 13, 2: 52, 3: 86, 4: 111, 5: 223 }[pasoActual]) === cap.seconds;
                        return (
                          <button
                            key={cap.seconds}
                            type="button"
                            onClick={() => setInicioManualGuiado(cap.seconds)}
                            className="btn btn-sm rounded-pill cap-btn"
                            style={
                              activo
                                ? { backgroundColor: 'var(--azul-ui)', borderColor: 'var(--azul-ui)', color: 'var(--blanco)' }
                                : { color: 'var(--color-text-primary)', borderColor: 'var(--color-border)' }
                            }
                          >
                            {cap.label}
                          </button>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="ratio ratio-16x9 rounded overflow-hidden">
                      <iframe
                        key={inicioVideoCompleto ?? `paso-${pasoActual}`}
                        src={`https://www.youtube.com/embed/NVGsw2uBKmo?rel=0&start=${inicioVideoCompleto ?? (INICIO_VIDEO_COMPLETO_POR_PASO[pasoActual] ?? 0)}`}
                        title="Tutorial completo para crear servicio"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      />
                    </div>

                    <div className="d-flex gap-2 mt-2" style={{ overflowX: 'auto', flexWrap: 'nowrap', paddingBottom: '4px' }}>
                      {CAPITULOS_VIDEO_COMPLETO.map((cap) => {
                        const activo = (inicioVideoCompleto ?? INICIO_VIDEO_COMPLETO_POR_PASO[pasoActual]) === cap.seconds;
                        return (
                          <button
                            key={cap.seconds}
                            type="button"
                            onClick={() => setInicioVideoCompleto(cap.seconds)}
                            className={`btn btn-sm rounded-pill cap-btn ${activo ? 'text-white' : ''}`}
                            style={
                              activo
                                ? { backgroundColor: 'var(--naranja-mapa)', borderColor: 'var(--naranja-mapa)' }
                                : { color: 'var(--naranja-mapa)', borderColor: 'var(--naranja-mapa)' }
                            }
                          >
                            {cap.label}
                          </button>
                        );
                      })}
                    </div>
                  </>
                )}

                <CardAyudarACrear className="mt-3" usuarioId={usuario?.idUsuario} />
              </div>
            </div>





            {/* Indicador de pasos */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <div className="d-flex align-items-start justify-content-between">
                  {[
                    { n: 1, label: 'Tipo' },
                    { n: 2, label: 'Descripción' },
                    { n: 3, label: 'Fotos' },
                    { n: 4, label: 'Paquetes' },
                    { n: 5, label: 'FAQ' },
                  ].map((step, index, arr) => (
                    <React.Fragment key={step.n}>
                      <button
                        type="button"
                        className="d-flex flex-column align-items-center text-center bg-transparent border-0 p-0"
                        style={{ minWidth: 52, cursor: 'pointer' }}
                        onClick={() => {
                          if (pasoActual === 1 && step.n === 2) {
                            cambiarTipoYpaso2();
                            return;
                          }
                          setPasoActual(step.n);
                        }}
                      >
                        {/* número del paso */}
                        <div
                          className={`rounded-circle d-flex align-items-center justify-content-center ${
                            pasoActual === step.n ? 'bg-primary text-white' : 'bg-light text-muted'
                          }`}
                          style={{ width: 32, height: 32, fontWeight: 600 }}
                        >
                          {step.n}
                        </div>
                        {/* nombre del paso */}
                        <small className="mt-2 fw-semibold" style={{ fontSize: '12px' }} > {step.label} </small>
                      </button>
                      {index < arr.length - 1 && (
                        <div
                          className="flex-grow-1 mx-2"
                          style={{
                            height: 2,
                            marginTop: 16,
                            backgroundColor: pasoActual > step.n ? 'var(--azul-bootstrap-cta)' : 'var(--color-border)',
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>





            {/* PASO 1: TIPO DE SERVICIO */}
            {pasoActual === 1 && (
              <Paso1
                tipoServicio={tipoServicio}
                setTipoServicio={setTipoServicio}
                tipoDesplazamiento={tipoDesplazamiento}
                setTipoDesplazamiento={setTipoDesplazamiento}
                servicioUrgente={servicioUrgente}
                setServicioUrgente={setServicioUrgente}
                cambiarTipoYpaso2={cambiarTipoYpaso2}
                divisaServicio={divisaServicio}
              />
            )}




            {/* PASO 2: NOMBRE, DESCRIPCIÓN, CATEGORÍA Y UBICACIÓN */}
            {pasoActual === 2 && (
              <Paso2
                formServicio={formServicio}
                setFormServicio={setFormServicio}
                cateConfig={cateConfig}
                tipoServicio={tipoServicio}
                tipoDesplazamiento={tipoDesplazamiento}
                divisaServicio={divisaServicio}
                categoriaSeleccionada={categoriaSeleccionada}
                setCategoriaSeleccionada={setCategoriaSeleccionada}
                subCategoriaSeleccionada={subCategoriaSeleccionada}
                setSubCategoriaSeleccionada={setSubCategoriaSeleccionada}
                subcategoriasDisponibles={subcategoriasDisponibles}
                paisSeleccionado={paisSeleccionado}
                zonaSeleccionada={zonaSeleccionada}
                setZonaSeleccionada={setZonaSeleccionada}
                zonas={zonas}
                ciudades={ciudades}
                setCiudades={setCiudades}
                subZonaTipo={subZonaTipo}
                setSubZonaTipo={setSubZonaTipo}
                subZonasPorCiudad={subZonasPorCiudad}
                setSubZonasPorCiudad={setSubZonasPorCiudad}
                ciudadSeleccionada={ciudadSeleccionada}
                setCiudadSeleccionada={setCiudadSeleccionada}
                direccionTexto={direccionTexto}
                setDireccionTexto={setDireccionTexto}
                referencia={referencia}
                setReferencia={setReferencia}
                latitud={latitud}
                longitud={longitud}
                setLatitud={setLatitud}
                setLongitud={setLongitud}
                setPrecisionUbicacion={setPrecisionUbicacion}
                guardarProgreso={guardarProgreso}
                setPasoActual={setPasoActual}
                BotonesaPasos={BotonesaPasos}
                ubicacionUsuario={usuario.ubicacionActual}
                usuarioActual={usuario}
                idServicio={servicio.idServicio}
                onSuccessIA={resultado => {
                  if (resultado.titulo)      setFormServicio(f => ({ ...f, titulo:      resultado.titulo }));
                  if (resultado.descripcion) setFormServicio(f => ({ ...f, descripcion: resultado.descripcion }));
                  if (resultado.paquete) {
                    setPaquetes(prev => ({
                      ...prev,
                      Basico: {
                        ...prev.Basico,
                        descripcion: resultado.paquete.descripcion || prev.Basico.descripcion,
                        detalles:    Array.isArray(resultado.paquete.detalles)
                          ? resultado.paquete.detalles.join("\n")
                          : prev.Basico.detalles,
                      },
                    }));
                  }
                  if (resultado.faq) {
                    setFaq([{ pregunta: resultado.faq.pregunta || "", respuesta: resultado.faq.respuesta || "" }]);
                    setCantidadFaq(1);
                  }
                  setFormServicio(f => ({ ...f, usoIA: (f.usoIA || 0) + 1 }));
                }}
              />
            )}

            


            {/* PASO 3: FOTOS */}
            {pasoActual === 3 && (
              <Paso3
                RECOM_MB={RECOM_MB}
                MAX_MB={MAX_MB}
                imagenesUI={imagenesUI}
                dropzonesImagenes={dropzonesImagenes}
                divisaServicio={divisaServicio}
                BotonesaPasos={BotonesaPasos}
                setPasoActual={setPasoActual}
                guardarProgreso={guardarProgreso}
              />
            )}



            {/* PASO 4 PAQUETES (MVP) */}
            {pasoActual === 4 && (
              <Paso4
                urgente={servicioUrgente}
                cantidadPaquetes={cantidadPaquetes}
                setCantidadPaquetes={setCantidadPaquetes}
                paqueteActivo={paqueteActivo}
                setPaqueteActivo={setPaqueteActivo}
                paquetes={paquetes}
                actualizarPaquete={actualizarPaquete}
                actualizarTodosPaquetes={actualizarTodosPaquetes}
                agendaAbierta={agendaAbierta}
                setAgendaAbierta={setAgendaAbierta}
                comisionHPM={comisionHPM}
                desgloseCobro={desgloseCobro}
                impuestoPais={impuestoPais}
                divisaServicio={divisaServicio}
                tipoServicio={tipoServicio}
                BotonesaPasos={BotonesaPasos}
                setPasoActual={setPasoActual}
                guardarProgreso={guardarProgreso}
              />
            )}


            
            {/* PASO 5: FAQ */}
            {pasoActual === 5 && (
              <Paso5
                cantidadFaq={cantidadFaq}
                asegurarFaqLongitud={asegurarFaqLongitud}
                faq={faq}
                actualizarFaq={actualizarFaq}
                divisaServicio={divisaServicio}
                BotonesaPasos={BotonesaPasos}
                setPasoActual={setPasoActual}
                guardarProgreso={guardarProgreso}
              />
            )}




          </div>
        </div>

        {/* BOTON PUBLICAR — visible en todos los pasos, no solo al final */}
        <div className="container px-4 px-md-5" style={{ position: 'sticky', bottom: 0, paddingBottom: '1rem', zIndex: 5 }}>
          <div className="bg-body-tertiary rounded-3 shadow-sm p-3">
            <ModalPublicar usuario={usuario} setUsuario={setUsuario} onPublicar={ponerEnRevision} validarServicio={construirErroresServicio} idServicio={idServicio} />
          </div>
        </div>
      </div>
    </div>
    : null
    }
    </div>
  )
}
  
  


export default CrearEditarServicio;